import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import RedirectPage from "./components/redirect";
import RedirectScan from "./components/redirectscan";
import MobileApp from "./components/mobileapp.js";
import Feedback from "./components/feedback";
import NotFound from "./components/notfound";
import RedirectSite from "./components/redirectsite.js";

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/mobileapp" element={<MobileApp />} />
          <Route path="/redirectsite" element={<RedirectSite />} />
          <Route path="/redirectscan" element={<RedirectScan />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/:id" element={<RedirectPage />} />
          <Route path="/redirect/:id" element={<RedirectPage />} />
          <Route path="/rd/:id" element={<RedirectPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
